import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import GenericSelect from '../elements/forms/GenericSelect'
import IntegerInput from '../elements/forms/IntegerInput'
import Dismissible from '../elements/Dismissible'
import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_NAME: 'Le nom ne peut pas être vide.',
  EMPTY_MONTHS: 'Le nombre de mois ne peut pas être vide',
  ZERO_MONTH: 'Le nombre de mois doit être plus grand que zéro',
  EMPTY_VALUE: 'La récurrence ne peut pas être vide'
}

class ControlForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputName = this.onChangeInputName.bind(this)
    this.onChangeInputPeriodic = this.onChangeInputPeriodic.bind(this)
    this.onChangeInputValue = this.onChangeInputValue.bind(this)
    this.onChangeInputRemark = this.onChangeInputRemark.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      name: (props.data && props.data.name) || '',
      periodic: (props.data && props.data.recurrence.periodic) ? 'true' : 'false',
      value: (props.data && props.data.recurrence.value) || '',
      remark: (props.data && props.data.remark) || ''
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputName(name) {
    this.setInput({ name })
  }

  onChangeInputPeriodic(periodic) {
    this.setInput({
      periodic,
      value: ''
    })
  }

  onChangeInputValue(value) {
    this.setInput({ value })
  }

  onChangeInputRemark(remark) {
    this.setInput({ remark })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!_.isString(this.state.input.name) || this.state.input.name.length === 0) {
      formErrors.push(ERROR.EMPTY_NAME)
    }
    if (this.state.input.periodic === 'true') {
      if (String(this.state.input.value).length === 0) {
        formErrors.push(ERROR.EMPTY_MONTHS);
      } else if (parseInt(this.state.input.value, 10) === 0) {
        formErrors.push(ERROR.ZERO_MONTH);
      }
    } else {
      if (!_.isString(this.state.input.value) || this.state.input.value.length === 0) {
        formErrors.push(ERROR.EMPTY_VALUE);
      }
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      _.pick(this.state.input, 'name', 'remark'),
      {
        recurrence: {
          periodic: this.state.input.periodic === 'true',
          value: this.state.input.value
        }
      }
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Ce contrôle existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          <TextInput
            label='Nom'
            placeholder='Contrôle général'
            value={this.state.input.name}
            onChange={this.onChangeInputName}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_NAME)
                ? ERROR.EMPTY_NAME
                : null
            }
          />
          <GenericSelect
            label='Récurrence'
            loading={false}
            options={[
              { key: 'false', value: 'Libre' },
              { key: 'true', value: 'Périodique' }
            ]}
            selected={this.state.input.periodic}
            onChange={this.onChangeInputPeriodic}
          />
          {
            this.state.input.periodic === 'true'
              ? <IntegerInput
                  label='Tous les (mois)'
                  placeholder='12'
                  value={this.state.input.value}
                  onChange={this.onChangeInputValue}
                  error={
                    _.contains(this.state.formErrors, ERROR.EMPTY_MONTHS)
                      ? ERROR.EMPTY_MONTHS
                      : (
                          _.contains(this.state.formErrors, ERROR.ZERO_MONTH)
                            ? ERROR.ZERO_MONTH
                            : null
                        )
                  }
                />
              : <TextInput
                  label=''
                  placeholder='Après chaque intervention'
                  value={this.state.input.value}
                  onChange={this.onChangeInputValue}
                  error={
                    _.contains(this.state.formErrors, ERROR.EMPTY_VALUE)
                      ? ERROR.EMPTY_VALUE
                      : null
                  }
                />
          }
          <TextInput
            label='Remarque'
            placeholder='...'
            value={this.state.input.remark}
            onChange={this.onChangeInputRemark}
            multiline={true}
          />
        </Form>
      </React.Fragment>
    )
  }
}

ControlForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object
}

export default ControlForm



// WEBPACK FOOTER //
// ./src/components/forms/ControlForm.js